import React from "react";
import { CONFIG } from "../config";
import { ProductImage } from "./ProductImage";

export default function CustomerResultsSection() {
  if (!CONFIG.showCustomerProof) return null;

  const resultImages = ["resultCollection1", "resultCollection4", "resultCollection5"];

  const extraResultImages = {
    1: "resultCollection2",
    2: "resultCollection3"
  };

  return (
    <section id="collection-results" className="bg-white pt-12 pb-16 md:pt-16 md:pb-20 border-b border-brand-border">
      <div className="max-w-[1120px] mx-auto px-4 md:px-6">
        
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="bg-brand-success text-white text-xs font-black uppercase px-3 py-1 rounded-full tracking-widest inline-block">
            SEND US YOUR RESULTS!
          </span>
        </div>

        {/* Testimonial Result Images */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-[1120px] mx-auto">
          {resultImages.map((key, idx) => (
            <div key={idx} className="flex flex-col gap-6">
              <ProductImage
                imageKey={key}
                sizes="(min-width: 768px) 33vw, 92vw"
                loading="lazy"
                testId={`customer-result-image-${idx + 1}`}
                className={`rounded-xl shadow-lg ${idx === 0 ? "md:scale-110" : ""}`}
              />
              {extraResultImages[idx] && (
                <ProductImage
                  imageKey={extraResultImages[idx]}
                  sizes="(min-width: 768px) 33vw, 92vw"
                  loading="lazy"
                  testId={`customer-result-image-extra-${idx + 1}`}
                  className="rounded-xl shadow-lg"
                />
              )}
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
